/* eslint-disable no-console, @typescript-eslint/no-explicit-any */
/**
 * 環境感知 Logger
 * 簡單的開發/生產環境日誌控制
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * 環境感知 Logger
 *
 * 日誌分級（符合業界標準）：
 * - dev: 開發專用除錯訊息（生產環境不輸出）
 * - info: 重要資訊（所有環境輸出，用於追蹤系統狀態）
 * - warn: 警告訊息（所有環境輸出）
 * - error: 錯誤訊息（所有環境輸出）
 */
export const logger = {
  /**
   * 開發環境專用除錯訊息
   * 用途：開發時的詳細追蹤、狀態檢查
   */
  dev: isDevelopment
    ? (message: string, ...args: any[]) => console.log(`🔧 ${message}`, ...args)
    : () => {},

  /**
   * 重要資訊（所有環境輸出）
   * 用途：系統初始化、關鍵操作完成、狀態變更
   *
   * 📝 設計決策：生產環境也輸出 INFO 級別日誌
   * - 符合業界標準（LOG4J、Winston 等日誌框架的 INFO 級別）
   * - 提升生產環境可觀測性（追蹤系統狀態、診斷問題）
   * - 用戶可透過瀏覽器 DevTools 的日誌過濾功能隱藏
   * - 若未來需減少輸出量，可考慮改用 console.debug（預設不顯示）
   */
  info: (message: string, ...args: any[]) => console.log(`ℹ️ ${message}`, ...args),

  /**
   * 警告訊息（所有環境輸出）
   * 用途：潛在問題、降級操作、可恢復錯誤
   */
  warn: (message: string, ...args: any[]) => console.warn(`⚠️ ${message}`, ...args),

  /**
   * 錯誤訊息（所有環境輸出）
   * 用途：嚴重錯誤、操作失敗、異常狀態
   */
  error: (message: string, ...args: any[]) => console.error(`❌ ${message}`, ...args),
};

/**
 * @deprecated 請改用 `logger.dev/info/warn/error`，這些別名將逐步移除
 */
export const { dev: logDev, info: logInfo, warn: logWarn, error: logError } = logger;
